export const MODAL_BACKDROP_TEST_ID = 'modal-backdrop';
